import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmartphone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 264,
	height: 347,
	viewBox: "0 0 264 347",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8426_21098)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M56.4215 227.24C56.4215 227.23 56.4215 227.22 56.4215 227.21C50.8967 228.408 24.837 224.429 24.9878 229.452C25.7535 245.688 25.6871 261.808 30.5586 277.455C30.9933 279.607 32.0136 280.13 34.3869 280.259C63.3932 282.73 92.2473 285.113 121.455 284.412C143.371 283.867 166.195 288.514 187.242 281.164C191.339 279.749 186.767 275.441 186.958 272.804C187.702 257.673 182.884 243.552 180.302 228.815C180.42 221.431 158.85 226.021 153.016 224.975C120.87 227.223 88.6456 227.196 56.4215 227.24ZM24.6836 223.822C53.1502 212.011 83.5058 216.915 113.557 217.198C129.35 216.401 144.646 215.892 160.29 214.895C165.213 213.584 177.799 217.739 178.224 211.34C175.386 165.319 165.79 119.806 164.502 73.7248C164.992 64.4435 164.303 59.2212 152.944 58.7727C121.85 54.3285 90.3651 58.5151 59.083 56.4806C56.6618 56.4145 54.1276 57.0626 51.8692 55.5527C49.7591 55.5609 47.2038 56.5327 44.9969 56.5831C39.0057 58.4706 16.9885 53.6353 19.3793 62.4834C22.5617 116.225 20.882 170.039 24.6836 223.822ZM199.754 276.396C220.956 304.773 105.552 292.501 90.4409 295.078C77.7923 294.944 65.2232 293.789 52.7416 291.887C45.0509 290.814 37.3223 287.264 29.611 290.273C22.6536 292.695 21.8855 277.264 20.3399 273.036C7.10139 204.656 8.48616 133.502 10.1156 64.0641C12.1406 41.439 50.3881 47.2128 67.5009 44.9025C100.984 43.9793 134.658 42.984 167.702 48.636C185.809 51.0499 178.613 73.8325 180.92 85.9088C182.147 102.014 184.102 118.077 185.556 134.16C188.9 171.805 192.25 209.616 198.612 246.908C200.001 256.935 202.213 269.533 197.72 277.793C198.83 277.723 199.679 277.656 199.754 276.396Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M249.308 257.605C242.028 255.86 217.411 255.899 227.926 244.503C236.644 236.447 276.606 257.221 249.308 257.605Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M-28.1629 185.109C-32.7573 185.388 -60.1424 181.224 -52.9806 175.078C-40.6825 169.008 11.9539 183.73 -28.1629 185.109Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M107.841 337.798C107.202 363.913 90.2059 325.514 94.8723 317.739C104.986 305.268 108.38 330.901 107.841 337.798Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M198.18 0.517115C200.631 0.227286 203.869 3.68805 202.003 5.61728C195.057 10.4021 180.835 26.3214 173.005 16.7707C170.889 6.52233 189.67 1.41742 198.18 0.517115Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M230.529 88.564C228.716 98.7399 213.719 96.6016 206.191 101.292C200.616 103.528 198.846 96.2873 202.63 93.3862C208.627 88.3491 224.901 80.3574 230.529 88.564Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M234.093 147.154C228.538 145.211 196.502 146.543 204.887 136.887C211.058 131.602 256.631 144.792 234.093 147.154Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M31.528 324.588C30.6426 327.368 29.9377 330.706 28.51 333.745C18.7933 354.843 14.4394 333.621 20.53 323.163C23.4624 316.832 30.8467 316.85 31.528 324.588Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M256.787 317.431C249.079 316.709 230.857 313.906 236.044 304.94C237.288 303.594 238.496 303.28 240.207 304.004C247.085 306.33 253.349 311.101 260.783 311.526C263.667 311.154 264.227 315.641 261.715 316.356C259.862 316.978 257.853 317.212 256.787 317.431Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M170.454 315.711C174.809 316.563 178.897 316.064 180.501 320.279C182.517 326.115 188.011 332.228 187.968 338.13C179.886 338.718 164.119 323.375 170.454 315.711Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M24.6257 24.0497C16.5775 23.1691 4.79317 13.0787 -0.0427824 6.74478C-1.49754 -11.4664 22.8329 19.3223 24.6257 24.0497Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M219.303 189.727C227.109 190.038 234.928 191.46 238.235 197.707C239.318 199.891 237.691 201.545 235.431 200.132C229.013 197.118 220.352 200.508 214.513 196.629C210.073 192.42 214.594 189.689 219.303 189.727Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M96.5186 14.6809C94.7292 18.6422 95.724 25.6244 91.2493 27.5051C78.6723 23.2032 92.9535 -0.480059 96.5186 14.6809Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M227.905 36.7091C250.589 39.525 229.35 45.1252 219.564 44.7377C209.253 39.6164 221.438 36.5496 227.905 36.7091Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M115.543 121.78C112.316 121.624 111.586 122.51 112.393 124.934C115.874 133.818 113.49 143.425 113.012 152.581C120.185 158.07 131.489 142.702 133.464 136.475C133.673 130.901 121.376 121.381 115.543 121.78ZM79.4278 123.137C68.0101 124.244 57.6257 129.862 50.1981 137.979C45.2269 142.217 72.9024 149.801 76.6662 152.303C84.0975 154.953 76.6848 139.753 78.8876 136.008C78.8409 131.876 81.8326 126.735 79.4278 123.137ZM135.251 119.366C151.545 135.527 147.508 138.915 133.731 155.668C122.176 166.781 104.037 164.713 88.8555 165.567C70.5312 165.577 54.1746 156.277 38.9489 147.747C32.3121 141.906 47.4321 131.778 49.9892 125.723C53.9557 122.951 51.8376 120 48.2534 118.224C45.225 116.448 36.5398 107.986 43.649 107.156C51.6019 106.911 53.8258 121.116 62.0691 116.906C77.2804 113.436 53.1823 98.9386 64.0355 92.8222C72.7855 93.2468 70.8277 111.212 79.8307 110.883C102.223 108.189 95.2342 109.081 96.6405 90.7795C103.771 81.6512 107.604 96.6729 105.364 102.545C103.855 108.956 106.432 109.624 112.067 108.954C116.639 108.189 112.456 100.066 117.47 97.1342C126.12 91.5449 123.745 104.393 122.358 108.767C121.592 112.262 126.441 112.56 128.677 114.237C129.747 114.746 130.698 114.789 131.689 113.839C148.024 98.6189 157.367 108.414 135.251 119.366Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M106.066 66.8091C110.804 67.5692 119.807 64.5743 121.825 69.7C121.564 73.0718 120.444 74.3593 117.093 74.4639C110.147 74.6809 103.189 74.7178 96.2396 74.6188C91.7632 75.0533 84.8824 70.9824 90.6987 67.6139C95.6795 66.2733 100.944 66.9691 106.066 66.8287C106.066 66.822 106.066 66.8153 106.066 66.8091Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M76.3868 71.4231C76.5364 78.5075 67.8205 81.2104 66.6603 73.3536C65.8576 67.799 75.1737 66.4455 76.3868 71.4231Z",
				fill: "#79C912",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M104.177 245.884C92.701 248.97 104.751 265.901 113.406 259.853C122 254.094 110.597 246.812 104.177 245.884ZM103.195 236.898C148.359 238.118 120.443 288.248 91.9366 262.191C85.3376 255.498 89.8604 247.496 91.6197 240.175C93.4313 236.758 99.6853 237.838 103.195 236.898Z",
				fill: "#79C912",
				fillOpacity: .2
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8426_21098",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 323,
			height: 347,
			fill: "white",
			transform: "translate(-59)"
		})
	}) })]
});
export default SvgSmartphone;
